<template>
	<div id="chart"></div>
</template>

<script>
	import c3 from 'c3'
	import _ from 'lodash'
	import moment from 'moment'

	module.exports = {
		props:['values'],
		methods : {
			loadChart: function () {

				if(!this.values){
					return;
				}

				var xAxis = ['x'];
				var cols = [];

				var i = 0;
				for(let day in this.values){
					var j = 0;
					for(let medName in this.values[day]){
						if(i == 0){
							cols[j] = [medName];
						}else{
							cols[j].push(this.values[day][medName]);
						}
						j++;
					}
					xAxis.push(day);
					i++;
				}

				cols.push(xAxis);

				console.log(cols);

				var chart = c3.generate({
					bindto: '#chart',
					data: {
						x: 'x',
						columns: cols,
						type: 'bar'
					},
					bar: {
						width: {
							ratio: 0.8
						}
					},
					axis : {
						x : {
							type : 'timeseries',
							tick: {
								format: function (x) { return moment(x).format('MMM DD'); }
							}
						},
						y: {
							tick: {
								format: function (d) {
									return (parseInt(d) == d) ? d : null;
								}
							}
						}
					}
				});
			}
		},
		watch: {
			'values': function (val, oldVal) {
				this.loadChart();
			}
		},
		mounted: function(){
			this.loadChart();
		}
	}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// BarChart.vue?78c27af3